import { useSidepanelVerticalLayout } from '../../hooks/use-sidepanel-vertical-layout'

export const UPCOMING_MIN_HEIGHT = 300
export const UPCOMING_MAX_HEIGHT = 362

// Home mounts before the header/footer observers publish their first values.
// Reserve the full resting chrome up front so the initial preview never shows
// rows that immediately disappear once those observers settle.
const HOME_RESERVED_CHROME_HEIGHT = 288
const PRIORITY_SECTIONS_FIXED_HEIGHT = 208
const PRIORITY_SECTION_ROW_HEIGHT = 44
const MIN_PRIORITY_SECTION_ITEMS = 1
const MAX_PRIORITY_SECTION_ITEMS = 10

export function getUpcomingMaxHeight(homeHeight: number): number {
  return Math.min(UPCOMING_MAX_HEIGHT, Math.max(UPCOMING_MIN_HEIGHT, homeHeight - PRIORITY_SECTIONS_FIXED_HEIGHT))
}

export function getPrioritySectionInitialItemLimit(homeHeight: number): number {
  const itemBudget = homeHeight - getUpcomingMaxHeight(homeHeight) - PRIORITY_SECTIONS_FIXED_HEIGHT
  const itemsPerSection = Math.floor(itemBudget / (PRIORITY_SECTION_ROW_HEIGHT * 2))

  return Math.min(MAX_PRIORITY_SECTION_ITEMS, Math.max(MIN_PRIORITY_SECTION_ITEMS, itemsPerSection))
}

interface HomeSectionLayout {
  upcomingMaxHeight: number
  prioritySectionInitialItemLimit: number
}

/**
 * Allocates Home's visible height before Recents: Upcoming has a bounded region,
 * then Ready for you and Reminders share the remaining row budget equally.
 */
export function useHomeSectionLayout(): HomeSectionLayout {
  const { height } = useSidepanelVerticalLayout()
  const homeHeight = Math.max(0, height - HOME_RESERVED_CHROME_HEIGHT)

  return {
    upcomingMaxHeight: getUpcomingMaxHeight(homeHeight),
    prioritySectionInitialItemLimit: getPrioritySectionInitialItemLimit(homeHeight),
  }
}
